import defaultItems from '../../common/defaultItems';
import getArrayIndices from '../common/getStateArrayIndices';
import { BEFORE } from '../../constants/misc';
import { IBlock, IElementType, IParagraph } from '../../types/content';
import elementTypes from '../../constants/elementTypes';

export default {
    updateColumnItemContent: (state: IBlock[], action: any) => {
        const { blockIndex, columnIdx, elmIdx, newContent } = action.payload;
        const { blockArrIdx, columnArrIdx, elmArrIdx } = getArrayIndices(state, blockIndex, columnIdx, elmIdx);
        state[blockArrIdx].content.columns[columnArrIdx].columnItems[elmArrIdx].content = newContent;
    },

    moveColumnItemContentToAnotherColumn: (state: IBlock[], action: any) => {
        const {
            draggedBlockIndex,
            draggedColumnIdx,
            draggedColumnItemIdx,
            blockIndex,
            columnIdx,
            elmIdx,
            content,
            type,
            position,
            indices,
        } = action.payload;
        const newElement = {
            type,
            content,
            elmIdx: indices.element[1],
        };
        const { blockArrIdx, columnArrIdx, elmArrIdx } = getArrayIndices(state, blockIndex, columnIdx, elmIdx);
        const draggedElementProp = getArrayIndices(state, draggedBlockIndex, draggedColumnIdx, draggedColumnItemIdx);

        if (draggedBlockIndex === blockIndex && draggedColumnIdx === columnIdx && draggedColumnItemIdx === elmIdx) {
            return state;
        }

        let toBeDeletedElmIdx = draggedElementProp.elmArrIdx;

        if (elmIdx) {
            const newElementArrIdx = position === BEFORE ? elmArrIdx : elmArrIdx + 1;
            const shouldIncreaseElmArrIdx =
                columnIdx === draggedColumnIdx && newElementArrIdx < draggedElementProp.elmArrIdx;
            toBeDeletedElmIdx = shouldIncreaseElmArrIdx ? toBeDeletedElmIdx + 1 : toBeDeletedElmIdx;
            state[blockArrIdx].content.columns[columnArrIdx].columnItems.splice(newElementArrIdx, 0, newElement);
        } else {
            state[blockArrIdx].content.columns[columnArrIdx].columnItems.push(newElement);
        }

        state[draggedElementProp.blockArrIdx].content.columns[draggedElementProp.columnArrIdx].columnItems.splice(
            toBeDeletedElmIdx,
            1
        );
    },

    duplicateColumnItem: (state: IBlock[], action: any) => {
        const { blockIndex, columnIdx, elmIdx, indices } = action.payload;
        const { blockArrIdx, columnArrIdx, elmArrIdx } = getArrayIndices(state, blockIndex, columnIdx, elmIdx);
        const element = state[blockArrIdx].content.columns[columnArrIdx].columnItems[elmArrIdx];
        const newElement = {
            ...element,
            elmIdx: indices.element[1],
        };
        state[blockArrIdx].content.columns[columnArrIdx].columnItems.splice(elmArrIdx, 0, newElement);
    },

    deleteColumnItem: (state: IBlock[], action: any) => {
        const { blockIndex, columnIdx, elmIdx } = action.payload;
        const { blockArrIdx, columnArrIdx, elmArrIdx } = getArrayIndices(state, blockIndex, columnIdx, elmIdx);
        state[blockArrIdx].content.columns[columnArrIdx].columnItems.splice(elmArrIdx, 1);
    },

    addNewColumnItem: (state: IBlock[], action: any) => {
        const { blockIndex, columnIdx, elmIdx, position, itemType, indices, initialContent = {} } = action.payload;
        const content = {
            ...defaultItems[itemType as keyof typeof defaultItems].content,
            ...initialContent,
        };
        const { blockArrIdx, columnArrIdx, elmArrIdx } = getArrayIndices(state, blockIndex, columnIdx, elmIdx);
        const newElement = {
            elmIdx: indices.element[0],
            type: itemType,
            content,
        };
        if (position) {
            // element was dragged in
            const newElementArrIdx = position === BEFORE ? elmArrIdx : elmArrIdx + 1;
            state[blockArrIdx].content.columns[columnArrIdx].columnItems.splice(
                newElementArrIdx,
                0,
                newElement as IElementType
            );
        } else {
            state[blockArrIdx].content.columns[columnArrIdx].columnItems.push(newElement as IElementType);
        }
    },

    updateColumnItemContentInMultipleBlock: (state: IBlock[], action: any) => {
        const { elements, property } = action.payload;
        const { key, value }: { key: string; value: number | string | null } = property;
        elements.forEach((elm: { blockIndex: string; columnIdx: string; elmIdx: string; type: string }) => {
            const { blockArrIdx, columnArrIdx, elmArrIdx } = getArrayIndices(
                state,
                elm.blockIndex,
                elm.columnIdx,
                elm.elmIdx
            );
            // @ts-ignore issues indexing content with key, might need actions to be typed
            state[blockArrIdx].content.columns[columnArrIdx].columnItems[elmArrIdx].content[key] = value;
        });
    },

    updateColumnItemFontInMultipleBlock: (state: IBlock[], action: any) => {
        const { elements, newFonts } = action.payload;
        elements.forEach((block: IBlock, blockIdx: number) => {
            block.content?.columns?.forEach((column, columnIdx) => {
                column.columnItems?.forEach((colItem, colItemIdx) => {
                    if (colItem.type === elementTypes.PARAGRAPH) {
                        const replacementFont = newFonts[(colItem.content as IParagraph).fontFamily];
                        if (replacementFont) {
                            (
                                state[blockIdx].content.columns[columnIdx].columnItems[colItemIdx].content as IParagraph
                            ).fontFamily = replacementFont.value;
                            (
                                state[blockIdx].content.columns[columnIdx].columnItems[colItemIdx].content as IParagraph
                            ).fontID = replacementFont.fontID || undefined;
                        }
                    }
                });
            });
        });
    },
};
